import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const MLUWIssuesBlockingPoints = {
    REJECTED: 'Rejected',
    BLOCKS_QUOTE: 'BlocksQuote',
    BLOCKS_QUOTE_RELEASE: 'BlocksQuoteRelease',
    BLOCKS_BIND: 'BlocksBind',
    BLOCKS_ISSUANCE: 'BlocksIssuance',
    NON_BLOCKING: 'NonBlocking'
};

const isRejectedUWIssue = (uwIssue) => {
    return uwIssue.hasApprovalOrRejection && uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.REJECTED;
};

const hasRejectedUWIssues = (uwIssues) => {
    return uwIssues.some((uwIssue) => isRejectedUWIssue(uwIssue));
};

const isBlockingUWIssue = (uwIssue, blockLevel) => {
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_ISSUANCE) {
        return uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_QUOTE || 
        uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_BIND || 
        uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_ISSUANCE;
    }
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_BIND) {
        return uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_QUOTE || 
        uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_BIND;
    }
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_QUOTE) {
        return uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    }
};

const wasBlockingUWIssue = (uwIssue, blockLevel) => {
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_ISSUANCE) {
        return uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_QUOTE ||
        uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_BIND ||
        uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_ISSUANCE;
    }
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_BIND) {
        return uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_QUOTE ||
        uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_BIND;
    }
    if (blockLevel === MLUWIssuesBlockingPoints.BLOCKS_QUOTE) {
        return uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    }
};

const hasBlockingUWIssues = (uwIssues, blockLevel) => {
    return uwIssues.some((uwIssue) => 
        isBlockingUWIssue(uwIssue, blockLevel) || 
        (wasBlockingUWIssue(uwIssue, blockLevel) && isRejectedUWIssue(uwIssue)));
};

export default class MLUWService {

    static isBlockedByUWIssues(uwIssues, blockLevel) {
        return hasRejectedUWIssues(uwIssues) || hasBlockingUWIssues(uwIssues, blockLevel)
    }

    static getUWIssues(uwRequestDTO, additionalHeaders = {}) {
        const url = getProxiedServiceUrl('underwriting');
        return JsonRPCService.send(
            url,
            'getUWIssues',
            [uwRequestDTO],
            additionalHeaders
        );
    }

    static approveOrRejectUWIssue(uwRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('underwriting'),
            'approveOrRejectUWIssue',
            [uwRequestDTO],
            additionalHeaders
        );
    }
}